import React from 'react';

import { ReactComponent as Status404 } from '@/assets/feedbacks/404.svg';

import MedflowLogo from '@/components/Logo/MedflowLogo';
import { ErrorContainer, Content, Footer } from './styles';

const NotFound: React.FC = () => {
  return (
    <ErrorContainer>
      <Content>
        <Status404 width={200} height={200} />

        <h3>Página não encontrada</h3>

        <p>
          A página que você está procurando não existe ou foi removida. Por
          favor, verifique o URL ou volte para a página anterior.
        </p>
      </Content>

      <Footer>
        <MedflowLogo color="primary" version="primary" />
      </Footer>
    </ErrorContainer>
  );
};

export default NotFound;
